import { getDuration } from '@nexelem/utils';

export const getOverdueDuration = (dueDate?: string, endDate?: string): string | undefined => {
  if (!dueDate || !endDate) {
    return;
  }

  const due = new Date(dueDate);
  const end = new Date(endDate);

  if (end > due) {
    return getDuration(new Date(due), new Date(end));
  }

  return;
};

export const getProductionDuration = (startDate?: string, endDate?: string, setupEnd?: string): string | undefined => {
  if (!startDate || !endDate) {
    return;
  }

  const start = new Date(startDate);
  const end = new Date(endDate);

  if (setupEnd) {
    const setupEndDate = new Date(setupEnd);
    return getDuration(setupEndDate, end);
  }

  return getDuration(start, end);
};

export const getRetoolingDuration = (startDate?: string, setupEndDate?: string): string | undefined => {
  if (!startDate || !setupEndDate) {
    return;
  }

  const start = new Date(startDate);
  const setupEnd = new Date(setupEndDate);

  return getDuration(start, setupEnd);
};
